export default "__VITE_ASSET__UtAmopUf__"